import { render, staticRenderFns } from "./RaUpgradeIcon.vue?vue&type=template&id=0f8abd84&scoped=true"
import script from "./RaUpgradeIcon.vue?vue&type=script&lang=js"
export * from "./RaUpgradeIcon.vue?vue&type=script&lang=js"
import style0 from "./RaUpgradeIcon.vue?vue&type=style&index=0&id=0f8abd84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8abd84",
  null
  
)

export default component.exports